import { PropsWithChildren, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { LANGUAGE_SELECT } from 'constant/constant';
import {
  getBrowserLocale,
  loadTranslationFile,
} from 'hooks/use-language-select';
import { getTranslationCache } from 'utils/translation-loader';

type LocaleIntlProviderProps = PropsWithChildren<{
  fallbackOnEmptyString?: boolean;
  defaultLocale?: string;
}>;

// to sync locale state across the app since we have multiple react-intl providers in different roots
export const LocaleIntlProvider = ({
  children,
  fallbackOnEmptyString,
  defaultLocale = 'en',
}: LocaleIntlProviderProps) => {
  const locale =
    (typeof window !== 'undefined'
      ? localStorage.getItem(LANGUAGE_SELECT)
      : null) ||
    getBrowserLocale() ||
    defaultLocale;

  // Initialize with cached English to prevent empty translations during initial render
  const [messages, setMessages] = useState<Record<string, string>>(
    () => getTranslationCache().get('en') || {},
  );

  useEffect(() => {
    loadTranslationFile(locale, true).then(setMessages);
  }, [locale]);

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      defaultLocale={defaultLocale}
      fallbackOnEmptyString={fallbackOnEmptyString}
    >
      {children}
    </IntlProvider>
  );
};
